import PropTypes from "prop-types";

const UpcomingEvents = ({ events }) => {
  // Format date to a more readable format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("sv-SE", {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (!events || events.length === 0) {
    return (
      <div className="bg-[#131313] border border-white/10 rounded-2xl p-6">
        <p className="text-stone-400 text-sm">Inga kommande evenemang just nu.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {events.map((event, index) => (
        <a
          key={event.slug || index}
          href={`/events/${event.slug}`}
          className="group block bg-[#131313] border border-white/10 rounded-2xl p-4 hover:bg-neutral-900/60 transition-all duration-300 hover:scale-[1.01] shadow-md"
        >
          <div className="flex gap-4">
            {event.image_main && (
              <div className="flex-shrink-0 w-28 aspect-[16/9] overflow-hidden rounded-lg border border-white/5">
                <img
                  src={event.image_main}
                  alt={event.name}
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <div className="flex-1 min-w-0">
              <h4 className="font-extrabold text-base truncate uppercase tracking-wide text-white group-hover:text-[#0047ff] transition-colors">
                {event.name}
              </h4>
              <div className="flex items-center gap-2 text-xs text-stone-400 mt-1.5">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-[#0047ff]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                  />
                </svg>
                <span>{formatDate(event.date)}</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-stone-400 mt-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4 text-[#0047ff]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
                <span className="truncate">{event.location}</span>
              </div>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};

UpcomingEvents.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      image_main: PropTypes.string,
      date: PropTypes.string.isRequired,
      location: PropTypes.string.isRequired,
    }),
  ),
};

export default UpcomingEvents;
